// extracted by mini-css-extract-plugin
export default {"main_wrapper":"TestPageLayout_main_wrapper__pln2X"};